import { render, staticRenderFns } from "./DetailProject.vue?vue&type=template&id=418f1ed0&scoped=true"
import script from "./DetailProject.vue?vue&type=script&lang=js"
export * from "./DetailProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418f1ed0",
  null
  
)

export default component.exports